import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from '../pages/admin/Dashboard';
import VolunteerPage from '../pages/admin/VolunteerPage';
import FarmerPage from '../pages/admin/FarmerPage';
import FarmerDatabasePage from '../pages/admin/FarmerDatabasePage';
import FarmerFormPage from '../pages/admin/FarmerFormPage';
import CompanyPage from '../pages/admin/CompanyPage';
import MappingPage from '../pages/admin/MappingPage';
import MappedDataPage from '../pages/admin/MappedDataPage';
import { useAuth } from '../context/AuthContext';

// This will be a protected route component for admin routes
const AdminRoutes = () => {
  const { isAuthenticated, role } = useAuth();

  // If not authenticated or not an admin, redirect to login
  if (!isAuthenticated || role !== 'admin') {
    return <Navigate to="/login" />;
  }

  return (
    <Routes>
      <Route path="dashboard" element={<Dashboard />} />
      <Route path="volunteers" element={<VolunteerPage />} />
      <Route path="farmer-database" element={<FarmerDatabasePage />} />
      <Route path="farmer-form" element={<FarmerFormPage />} />
      <Route path="farmer-form/:id" element={<FarmerFormPage />} />
      <Route path="companies" element={<CompanyPage />} />
      <Route path="mapping" element={<MappingPage />} />
      <Route path="mapped-data" element={<MappedDataPage />} />
      <Route path="*" element={<Navigate to="dashboard" />} />
    </Routes>
  );
};

export default AdminRoutes;
